module.exports = __webpack_public_path__ + "img/51626506_L.61f56d06.png";